import {
    DEFAULT_IMAGE_OVERLAY,
    colorToHex8,
    hasExplicitAlpha,
    isTransparentColor
} from '~/utils/TemplateEditor/landingBackground'

const CLEAR_IMAGE_OVERLAY = 'transparent'

function withTransparentColour(globalColours) {
    const colours = (JSON.parse(JSON.stringify(globalColours)) || []).filter(Boolean)
    if (!colours.includes('transparent')) colours.push('transparent')
    return colours
}

function backgroundImageKeyForColorPath(path) {
    const match = String(path || '').match(/(rowBg|column(?:\d+)?Bg)(?:\.value)?$/)
    return match ? match[1] + 'Image' : null
}

function hasBackgroundImageForColorPath(props) {
    if (!props.allowAlpha) return false
    const imageKey = backgroundImageKeyForColorPath(props.path)
    const imageVal = props.localVariables && props.localVariables[imageKey] && props.localVariables[imageKey].value
    return !!imageVal && imageVal !== 'none'
}

function overlayPickerColor(props) {
    if (!hasBackgroundImageForColorPath(props)) return props.value
    if (isTransparentColor(props.value)) return 'transparent'
    if (hasExplicitAlpha(props.value)) return colorToHex8(props.value) || props.value
    return DEFAULT_IMAGE_OVERLAY
}

function toHexByte(value) {
    return Math.max(0, Math.min(255, Math.round(Number(value) || 0)))
        .toString(16)
        .padStart(2, '0')
}

function rgbToHex(rgb) {
    if (!rgb || typeof rgb !== 'string') return rgb
    if (rgb.indexOf('rgb') === -1) return rgb

    const rgbaMatch = rgb.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([0-9.]+))?\s*\)$/i)
    if (!rgbaMatch) return rgb

    const red = toHexByte(rgbaMatch[1])
    const green = toHexByte(rgbaMatch[2])
    const blue = toHexByte(rgbaMatch[3])
    const alpha = rgbaMatch[4] === undefined ? 1 : Number(rgbaMatch[4])
    let hex = `#${red}${green}${blue}`
    if (!Number.isNaN(alpha) && alpha < 1) {
        hex += toHexByte(alpha * 255)
    }
    return hex.toLowerCase()
}

function hexToRgb(hex) {
    const fallback = { r: 0, g: 0, b: 0, a: 1 }
    if (!hex || typeof hex !== 'string') return fallback

    const rgbaMatch = hex.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([0-9.]+))?\s*\)$/i)
    if (rgbaMatch) {
        return {
            r: Number(rgbaMatch[1]),
            g: Number(rgbaMatch[2]),
            b: Number(rgbaMatch[3]),
            a: rgbaMatch[4] === undefined ? 1 : Number(rgbaMatch[4])
        }
    }

    let digits = hex.replace(/^#/, '')
    if (digits.length === 3) {
        digits = digits
            .split('')
            .map((character) => character + character)
            .join('')
    }
    if (digits.length !== 6 && digits.length !== 8) return fallback
    if (!/^[0-9a-f]+$/i.test(digits)) return fallback

    return {
        r: parseInt(digits.slice(0, 2), 16),
        g: parseInt(digits.slice(2, 4), 16),
        b: parseInt(digits.slice(4, 6), 16),
        a: digits.length === 8 ? parseInt(digits.slice(6, 8), 16) / 255 : 1
    }
}

export {
    CLEAR_IMAGE_OVERLAY,
    withTransparentColour,
    backgroundImageKeyForColorPath,
    hasBackgroundImageForColorPath,
    overlayPickerColor,
    rgbToHex,
    hexToRgb
}
